//Login.js
import React from 'react';
import md5 from 'js-md5'
import cookie from 'react-cookies'

import Config from '../config/Config';
import Widget from './../widget/Widget'
import WidgetAjax from './../widget/WidgetAjax'

import '../css/login.css';

React.Component.prototype.$md5 = md5

class Login extends React.Component {

    constructor( ) 
    {
        super();

        sessionStorage.removeItem("_user_token_");
        sessionStorage.removeItem("UID");

        this.state = {
            loading : false,
            username : '',
            password : '',
            verificationCode : '',
            windowType:1,
        };

        // 获取组件自身
        this.myRef = React.createRef();

        this.login = this.login.bind(this);
        this.onLogin = this.onLogin.bind(this);
        this.hideError = this.hideError.bind(this);
        this.handleUserChange = this.handleUserChange.bind(this);
        this.handlePassWordChange = this.handlePassWordChange.bind(this);
        this.handleVerificationCodeChange = this.handleVerificationCodeChange.bind(this);
        
        this.typeChange = this.typeChange.bind(this);

        this.onKeyup = this.onKeyup.bind(this);
    }


    typeChange( type )
    {
        this.setState({
            windowType : type
        });
    }

    /**
    * 键盘事件捕获
    * @param {*} e 
    */
     onKeyup( e )
     {
         if(e.keyCode === 13) 
         {
             this.login()
         }
     }

    login()
    {
        let {username, password} = this.state;

        // TODO 验证用户
        if( username==="" )
        {
            this.myRef.current.innerHTML = "用户名不能为空!";

            this.myRef.current.parentElement.style.display = 'block';

            return ;
        }

        if( password==="" )
        {
            this.myRef.current.innerHTML = "密码不能为空!";

            this.myRef.current.parentElement.style.display = 'block';
            
            return ;
        }       

        password = this.$md5("ES_6ps" + password + "_N3tM").toUpperCase();

        WidgetAjax.ajax({url : Config.getBasePath()+'/login', params : {username:username, secret:password}, callback : this.onLogin});

    }

    onLogin(result, params )
    {
        if( result.status===0 )
        {
            Widget.clearSessionStorage();

            sessionStorage.setItem("_user_access_", result.access);
            
            if(result.user_info!==undefined && result.user_info.extensions!==undefined && 
                result.user_info.extensions.access!==undefined )
            {
                localStorage.setItem("access_token", result.user_info.extensions.access);
            }

            Widget.removeSessionStorage("_left_node_activeKey_");
            Widget.removeSessionStorage("_left_node_openKey_");

            sessionStorage.setItem("_user_info_", JSON.stringify(result.user_info));
            sessionStorage.setItem("_user_login_info_", JSON.stringify(result));

            cookie.save("_user_login_info_", result, {path:"/"});
            
            this.props.history.push({pathname:'/home', state:{isLogin:true}});
        }
        else
        {
            this.myRef.current.innerHTML = result.message;
            this.myRef.current.parentElement.style.display = 'block';
        }
    }

    hideError()
    {
        this.myRef.current.innerHTML = "";
        this.myRef.current.parentElement.style.display = 'none';
    }

    handleUserChange( event )
    {
        this.myRef.current.parentElement.style.display = 'none';

        this.setState({
            username:event.target.value
        });
    }

    handlePassWordChange( event ) 
    {
        this.myRef.current.parentElement.style.display = 'none';

        this.setState({
            password: event.target.value
        });
    }

    handleVerificationCodeChange( event )
    {
        this.myRef.current.parentElement.style.display = 'none';
        
        this.setState({
            verificationCode: event.target.value
        });
    }

    render() 
    {
        let {windowType} = this.state

        return (
            <div className="login-html-body"> 
                {/* <img src={require("../img/logo.png")} className="logo" alt="es-lint want to get" />  */}
                <div> 
                    <img src={require("../img/login.png")} className="img-back" alt="es-lint want to get" />
                </div>
                <div>
                    <div className="login-title">
                        {/* <img src={require("../img/bt_bank.png")} alt="es-lint want to get" style={{transform: 'scale(1.5,1.5)'}}/> */}
                        银行对公营销获客系统
                    </div> 
                    <div className="login-box" onKeyUp={this.onKeyup}>
                        <div className="bodyOut" >
                            <div className="body">
                                <div style={{marginbottom:15}} >
                                    <div className="alert alert-info login-alert" id="alerterror" role="alert" style={{display:'none'}}>					
                                        <span className="glyphicon glyphicon-warning-sign" aria-hidden="true"></span>
                                        &nbsp;&nbsp;
                                        <span id="errorinfo" ref={this.myRef} className="login-alert-errorinfo"></span>
                                        <button type="button" className="close" onClick={this.hideError} >
                                            <span aria-hidden="true">&times;</span><span className="sr-only">Close</span>
                                        </button>
                                    </div>
                                </div>

                                <div className="login-tag">
                                    <div className="login-tag-u1 longin-bank">
                                        {/* <div className="login-tag-u2">
                                            <label className={windowType===1?"login-label-common label_active":"login-label-common"} onClick={() => { this.typeChange(1) }}>账号登录</label>
                                        </div>
                                        <div className="login-tag-u2">
                                            <label className={windowType===2?"login-label-common label_active":"login-label-common"} onClick={() => { this.typeChange(2) }}>扫码登录</label>
                                        </div> */}

                                        <label className="login-label-common" onClick={() => { this.typeChange(1) }}>账号登录</label>
                                    </div>
                                </div>


                                <div style={windowType===1?{display:"block", clear:'both'}:{display:"none"}}>
                                    <div className="form-group login-row">
                                        <div className="col-sm-12 login-input-title input-group">
                                            <i className="icon-user"></i>
                                            <input type="text" onChange={this.handleUserChange} className="form-control login-input" placeholder="请输入您的用户名" title="请输入您的用户名" />
                                        </div>
                                    </div>
                                    
                                    <div className="form-group login-row">
                                        <div className="col-sm-12 login-input-title input-group">
                                            <i className="icon-password"></i>
                                            <input type="password" onChange={this.handlePassWordChange} className="form-control login-input" placeholder="请输入您的密码" title="请输入您的密码" />
                                        </div>
                                    </div>

                                    <div className="form-group login-row" style={{width: "70%",float: 'left'}}>
                                        <div className="col-sm-12 login-input-title input-group">
                                            <i className="icon-verificationcode"></i>
                                            <input type="text" onChange={this.handleVerificationCodeChange} className="form-control login-input" placeholder="请输入您的验证码" title="请输入您的验证码" />
                                        </div>
                                    </div>

                                    <div className="form-group login-row verification-code">
                                        <div className="col-sm-12 login-input-title input-group">

                                        </div>
                                    </div>
                            
                                    <div className="form-group login-button-group">
                                        <input type="button" id="loginbtn" onClick={this.login} className="btn btn-primary login-row login-btn" data-loading-text="" value="登录" />
                                    </div>
                                </div>
                                <div style={windowType===2 ? {display:"block", clear:'both'} : {display:"none"}}>

                                </div>
                            
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        )
    }
}

export default Login